import React from "react";
import TrSelect from "../../shared/controls/TrSelect";
import { TransportOptionType } from "../../../models/transport-option-type/TransportOptionType";
import { Grid } from "@material-ui/core";
import SchoolCarrierTransportItem from "./SchoolCarrierTransportItem";
import PersonalTransportItem from "./PersonalTransportItem";
import AuthorizedCarrierTransportItem from "./AuthorizedCarrierTransportItem";
import CompanionInPublicTransportItem from "./CompanionInPublicTransportItem";
import FinancingRequestStudentData from "../../../models/financing-request/student-data/FinancingRequestStudentData";
import { SchoolCarrier } from "../../../models/financing-request/SchoolCarrier";
import FinancingRequestStudent from "../../../models/financing-request/FinancingRequestStudent";
import TrSelectData from "../../../models/shared/TrSelectData";
import { PersonalPassenger } from "./FinancingRequestStudentDataStep";
import SelectItem from "../../../models/shared/SelectItem";
import { VehicleType } from "../../../models/vehicle-type/VehicleType";
import ValidationResult from "../../../hooks/change-tracker/ValidationResult";
import TrackerName from "../../../models/financing-request/student-data/FinancingRequestStudentDataTrackerName";
import { nameof } from "../../../utilities/utilities";
import { TransportOption } from "../../../models/financing-request/transport-option/TransportOption";
import { AuthorizedCarrier } from "../../../models/financing-request/AuthorizedCarrier";
import Currency from "../../../models/shared/Currency";

interface Props {
  index: number;
  studentData: FinancingRequestStudentData;
  studentsData: FinancingRequestStudentData[];
  personalPassengers: PersonalPassenger[];
  schoolCarriers: SchoolCarrier[];
  authorizedCarriers: AuthorizedCarrier[];
  currency: Currency;
  transportOptionTypeItems: SelectItem<TransportOptionType>[];
  vehicleTypeItems: SelectItem<VehicleType>[];
  validationResult: ValidationResult;
  onTransportTypeChange: (studenId: number) => (e: any) => void;
  onTransportSelectChange: (studenId: number) => (e: any) => void;
  onTransportChange: (studenId: number) => (e: any) => void;
  handleTransportSelectChangeMultipleStudents: (
    studenId: number
  ) => (e: any) => void;
}

export default function TransportItem({
  index,
  studentData,
  studentsData,
  personalPassengers,
  schoolCarriers,
  authorizedCarriers,
  currency,
  transportOptionTypeItems,
  vehicleTypeItems,
  validationResult,
  onTransportTypeChange,
  onTransportSelectChange,
  onTransportChange,
  handleTransportSelectChangeMultipleStudents,
}: Props) {
  function getSelectedStudents(): FinancingRequestStudent[] {
    let selectedStudents = new Array<FinancingRequestStudent>();
    studentsData.forEach((stData) => {
      if (
        stData.student.isSelected &&
        (stData.transportOption == null ||
          (stData.transportOption != null &&
            (stData.transportOption.transportOptionType == null ||
              stData.transportOption.transportOptionType ==
                TransportOptionType.PersonalPassenger))) &&
        stData.student.id !== studentData.student.id &&
        personalPassengers.find(
          (personalPassenger) =>
            personalPassenger.passengerId == stData.student.id &&
            personalPassenger.personal.id !== studentData.student.id
        ) == null
      ) {
        selectedStudents.push(stData.student);
      }
    });

    return selectedStudents;
  }

  function getTransportOptionComponent(studentId: number) {
    if (studentData.transportOption) {
      switch (studentData.transportOption.transportOptionType) {
        case TransportOptionType.SchoolCarrier:
          return (
            <SchoolCarrierTransportItem
              index={index}
              vehicleTypeItems={vehicleTypeItems}
              transportOption={studentData.transportOption}
              schoolCarriers={schoolCarriers}
              validationResult={validationResult}
              onSelectChange={onTransportSelectChange(studentId)}
            />
          );
        case TransportOptionType.Personal:
          return (
            <PersonalTransportItem
              index={index}
              selectedStudents={getSelectedStudents()}
              transportOption={studentData.transportOption}              
              validationResult={validationResult}
              onSelectChange={handleTransportSelectChangeMultipleStudents(
                studentId
              )}
              onChange={onTransportChange(studentId)}
            />
          );
        case TransportOptionType.AuthorizedCarrier:
          return (
            <AuthorizedCarrierTransportItem
              index={index}
              authorizedCarriers={authorizedCarriers}
              transportOption={studentData.transportOption}
              validationResult={validationResult}
              currency={currency}
              onSelectChange={onTransportSelectChange(studentId)}
            />
          );
        case TransportOptionType.CompanionInPublicTransport:
          return (
            <CompanionInPublicTransportItem
              index={index}
              transportOption={studentData.transportOption}
              validationResult={validationResult}
              currency={studentData.currency}
              onChange={onTransportChange(studentId)}
              onSelectChange={onTransportSelectChange(studentId)}
            />
          );
        default:
          return null;
      }
    }
    return null;
  }

  function getTransportOptionType() {
    let transporItems = new Array<SelectItem<TransportOptionType>>();
    transportOptionTypeItems.forEach((item) => {
      if (
        !(
          (item.value == TransportOptionType.SchoolCarrier &&
            schoolCarriers.length == 0) ||
          (item.value == TransportOptionType.AuthorizedCarrier &&
            authorizedCarriers.length == 0)
        )
      ) {
        transporItems.push(item);
      }
    });

    const selectTypeData: TrSelectData<SelectItem<TransportOptionType>> = {
      valueProp: "value",
      textProp: "text",
      data: transporItems,
    };

    return selectTypeData;
  }

  return (
    <>
      {studentData.transportOption ? (
        <Grid container item xs={12} spacing={4} className="noMarginPadding">
          <Grid item lg={3} md={6} sm={12} xs={12}>
            <TrSelect
              required
              value={studentData.transportOption.transportOptionType}
              className="selectFormControl"
              label="Vrsta prijevoza"
              onChange={onTransportTypeChange(studentData.student.id)}
              selectData={getTransportOptionType()}
              error={
                !validationResult.isArrayPropertyWithParrentValid(
                  TrackerName.StudentsData,
                  index.toString(),
                  nameof<FinancingRequestStudentData>("transportOption"),
                  nameof<TransportOption>("transportOptionType")
                )
              }
            ></TrSelect>
          </Grid>
          {getTransportOptionComponent(studentData.student.id)}
        </Grid>
      ) : (
        <></>
      )}
    </>
  );
}
